import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaireHelmet } from "@faire/retailer-visitor-shared/components/Helmet/index";
import { LazyLoggedOutMobileSignUpSnackbar } from "@faire/retailer-visitor-shared/components/LoggedOutMobileSignUpSnackbar/index";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import * as RetailerPaths from "@faire/retailer-visitor-shared/paths/index";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { LoggedOutHomePageBase } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/LoggedOutHomePageBase";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { getCountryDisplayNameFromSessionCountry } from "@faire/web--source/common/localization/getCountryDisplayNameFromSessionCountry";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Flex } from "@faire/web--source/slate/Layout";
import qs from "query-string";
import React, { Suspense } from "react";
import { Redirect, useLocation } from "react-router-dom";
var HardRedirect = function(param) {
    var to = param.to;
    getLocationOrThrow().href = to;
    return null;
};
export var LoggedOutHomePage = function(param) {
    var builderPromise = param.builderPromise;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var location = useLocation();
    var countryDisplayName = getCountryDisplayNameFromSessionCountry(getSessionCountry(), strictLocalize);
    var getTitle = function() {
        return countryDisplayName ? strictLocalize({
            id: "OhGAhW",
            defaultMessage: [
                {
                    type: 0,
                    value: "Faire "
                },
                {
                    type: 1,
                    value: "country"
                },
                {
                    type: 0,
                    value: " - Online Wholesale Marketplace for Retailers & Brands"
                }
            ]
        }, DEPRECATED_backwardsCompatibleValues({
            country: countryDisplayName
        })) : strictLocalize({
            id: "2OIthz",
            defaultMessage: [
                {
                    type: 0,
                    value: "Faire - Online Wholesale Marketplace for Retailers & Brands"
                }
            ]
        });
    };
    var retailer = useRetailer().retailer;
    var query = qs.parse(location.search);
    if (query.ad) {
        return /*#__PURE__*/ _jsx(HardRedirect, {
            to: "/ad/".concat(query.ad)
        });
    }
    if (retailer && retailer.token) {
        return /*#__PURE__*/ _jsx(Redirect, {
            to: RetailerPaths.home(query)
        });
    }
    return /*#__PURE__*/ _jsxs(Flex, {
        children: [
            /*#__PURE__*/ _jsx(FaireHelmet, {
                title: getTitle(),
                description: strictLocalize({
                    id: "dTL5/q",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Hundreds of thousands of retailers are buying wholesale products online with Faire. Order from thousands of independent wholesale vendors with net 60 terms & free returns today."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(LoggedOutHomePageBase, {
                builderPromise: builderPromise
            }),
            /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyLoggedOutMobileSignUpSnackbar, {})
            })
        ]
    });
};
